import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { MessageService } from 'primeng/api';
import { MessageModule } from 'primeng/message';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'configuration-sign-in',
    standalone: true,
    imports: [ReactiveFormsModule, CommonModule, ButtonModule, MessageModule, ToastModule],
    templateUrl: './configuration-sign-in.component.html',
    styleUrl: './configuration-sign-in.component.less',
    providers: [MessageService],
})
export class ConfigurationSignInComponent {
    loginForm: FormGroup;

    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        private http: HttpClient,
        private messageService: MessageService
    ) {
        this.loginForm = this.formBuilder.group({
            userName: ['', Validators.required],
            password: ['', Validators.required],
        });
    }

    onSubmit() {
        if (this.loginForm.valid) {
            const credentials = this.loginForm.value;
            this.http
                .post(`${environment.apiUrl}/Login`, credentials, {
                    withCredentials: true,
                })
                .subscribe({
                    next: (res: any) => {
                        this.router.navigate(['/configuration/detail']);
                    },
                    error: (err: any) => {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Login failed! Please try later.',
                        });
                    },
                });
        }
    }
}
